import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Typography } from "antd";
import { DrawBoard, DrawSection, InputSection, SignMethodSection } from "./Sections";

import "./styles.scss";

const props = {
    imageRef: PropTypes.object.isRequired,
    setImageReady: PropTypes.func.isRequired,
    originImage: PropTypes.string,
    qrcode: PropTypes.string,
    setQrcodeLoaded: PropTypes.func,
    topText: PropTypes.string,
    bottomText: PropTypes.string,
};

const SignatureImageBoard = ({
    imageRef,
    setImageReady,
    originImage,
    qrcode,
    setQrcodeLoaded,
    topText,
    bottomText,
}) => {
    const { t } = useTranslation();

    const [signMethod, setSignMethod] = useState("input");
    const [text, setText] = useState("");

    useEffect(() => {
        if (imageRef.current) imageRef.current.insertText(text);
    }, [text]); // eslint-disable-line

    return (
        <div className="signature-image-board">
            <Typography.Title level={5} className="mt-0" type="secondary">
                {t("chooseSignMethod")}
            </Typography.Title>

            <SignMethodSection
                signMethod={signMethod}
                onChange={(signMethod) => {
                    setSignMethod(signMethod);
                    imageRef.current?.clearCanvas();
                    setImageReady(false);
                    setText("");
                }}
                clearSignImageHandler={() => {
                    imageRef.current?.clearCanvas();
                    setImageReady(false);
                    setText("");
                }}
            />

            {signMethod === "input" && <InputSection text={text} onChange={(text) => setText(text)} />}
            {signMethod === "draw" && <DrawSection />}

            <DrawBoard
                ref={imageRef}
                originImage={originImage}
                qrcode={qrcode}
                setQrcodeLoaded={setQrcodeLoaded}
                topText={topText}
                bottomText={bottomText}
                disabled={signMethod !== "draw"}
                setImageReady={setImageReady}
            />
        </div>
    );
};

SignatureImageBoard.propTypes = props;

export default SignatureImageBoard;
